import MuiPagination from "@mui/material/Pagination";
const Pagination = MuiPagination;
export default Pagination;
